<script setup lang="ts">
const { external = false, small = false } = defineProps<{
  external?: boolean;
  small?: boolean;
}>();

const classObject = computed(() => ({
  "is-small": small,
}));
</script>

<template>
  <div class="menu-item" :class="classObject">
    <label class="label"><slot></slot></label>
    <BaseIcon v-if="external" name="open_in_new" class="external" />
  </div>
</template>

<style lang="scss" scoped>
.menu-item {
  display: flex;
  align-items: center;
  font-size: 2rem;
  padding: 5px 30px;
  cursor: pointer;

  .external {
    position: relative;
    margin-left: 0.2em;
    top: 0.1em;
    font-size: 0.8em;
  }

  &.is-small {
    font-size: 1.4rem;

    .external {
      top: 0.15em;
    }
  }

  &:hover {
    .label {
      text-decoration: underline;
    }
  }
}
</style>
